import {Divider} from '@material-ui/core'
import {styled} from '@mui/material/styles'

const DividerMargin = styled(Divider)(() => ({
  'margin': '10px',
}))

export default DividerMargin
